import {Component} from '@angular/core';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {Backend} from '@generated-backend-types';
import {RouterLink} from '@angular/router';
import {TranslatePipe} from '@ngx-translate/core';
import {UserSessionService} from '../../services/user-session.service';
import {FormErrorService} from '../../services/form-error.service';
import DashboardLoginData = Backend.App.Data.Dashboard.Auth.DashboardLoginData;
import {FormGroupComponent} from '../../components/form-inputs/form-group/form-group.component';

@Component({
  selector: 'app-auth-login',
  templateUrl: './login.component.html',
  imports: [
    ReactiveFormsModule,
    RouterLink,
    TranslatePipe,
    FormGroupComponent
  ]
})
export class LoginComponent {
  public loginForm = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', [Validators.required]),
  });

  public constructor(
    private userSessionService: UserSessionService,
    private formErrorService: FormErrorService,
  ) {}

  public onSubmit() {
    const data = this.loginForm.value as DashboardLoginData;

    this.userSessionService.loginUser(data).subscribe({
      error: response => this.formErrorService.mapErrorToForm(this.loginForm, response),
    });
  }
}
